import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {Observable} from "rxjs";
import {filter, map, switchMapTo} from "rxjs/operators";
import {ObservableBaseForm} from "../../shared/forms/observable-base.form";
import {AddSingleFormatToCartModel} from "../../shared/models/cart/add-single-format-to-cart.model";
import {ProductModel} from "../../shared/models/product/product.model";
import {QuickShopFormModel} from "../models/forms/quick-shop-form.model";

export class QuickShopForm extends ObservableBaseForm<QuickShopFormModel> {
    public get formats(): FormArray {
        return this.formInstance.get("formats") as FormArray;
    }

    public static createForm(formBuilder: FormBuilder, initialValues: QuickShopFormModel = new QuickShopFormModel()): QuickShopForm {
        const form = formBuilder.group({
            formats: formBuilder.array([], control => {
                if (!control.value.length) {
                    return {empty: true};
                }

                if (control.value.indexOf(null) > -1) {
                    return {hasNullEntries: true};
                }

                if (control.value.find((x: AddSingleFormatToCartModel) => !x.format)) {
                    return {hasEmptyFormat: true};
                }

                if (control.value.find((x: AddSingleFormatToCartModel) => !x.quantity)) {
                    return {hasEmptyQuantity: true};
                }

                return null;
            })
        });

        return new QuickShopForm(form, initialValues, formBuilder);
    }

    public constructor(
        formInstance: FormGroup,
        initialValues: QuickShopFormModel,
        private formBuilder: FormBuilder
    ) {
        super(formInstance, initialValues);
    }

    protected createChangeSubscription(): Observable<QuickShopFormModel> {
        return this.formats.valueChanges
            .pipe(
                switchMapTo(this.formInstance.statusChanges
                    .pipe(filter(this.validate))
                ),
                map(status => this.getModel())
            );
    }

    public reset(): void {
        while (this.formats.length !== 0) {
            this.formats.removeAt(0);
        }
    }

    public addProduct(product: ProductModel): void {
        this.formats.push(this.formBuilder.control(new AddSingleFormatToCartModel(product.id)));
    }

    public removeProduct(index: number): void {
        this.formats.removeAt(index);
    }
}
